import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TermsWidgetComponent } from './terms-widget/terms-widget.component';
import { AppModalModule } from '../modal/modal.module';
import { TermsService } from './terms.service';



@NgModule({
  imports: [
    CommonModule,
    AppModalModule,
  ],
  declarations: [
    TermsWidgetComponent,
  ],
  exports: [
    TermsWidgetComponent,
  ],
  providers: [TermsService]
})
export class TermsModule { }
